export default __webpack_public_path__ + "static/media/snapfooder_female.54d29ec0.svg";